module.exports = "<div ng-attr-class=\"ribbon ribbon-left-corner {{className}}\"><span>{{label}}</span></div>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/customer-reviews/cards/ribbon-template.html
 ** module id = 918
 ** module chunks = 1
 **/